import { BigText } from '../styles/MultiUsageStyles'

const WelcomePage = () => {
  return (
    <div>
      <BigText>Welcome to the PokeApp!</BigText>
    </div>
  )
}

export default WelcomePage;